import { render, staticRenderFns } from "./SingleModal.vue?vue&type=template&id=030518a2&scoped=true&"
import script from "./SingleModal.vue?vue&type=script&lang=js&"
export * from "./SingleModal.vue?vue&type=script&lang=js&"
import style0 from "./SingleModal.vue?vue&type=style&index=0&id=030518a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "030518a2",
  null
  
)

export default component.exports